export const HELP_FORM_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLScIM7A8IxlGCPHT8kLcDYCISJHDNqxluuXfLwVxS8KGSsECiw/viewform";
